if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        // Attach debounced slide change listener
        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        // Set up click listeners on thumbnails
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        // Remove semantic list roles on desktop if configured to use thumbnails
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }

        // Listen for variant change and update product images dynamically
        document.addEventListener('DOMContentLoaded', () => {
          const variantSelect = document.querySelector('select[name="id"]'); // Variant selector dropdown
          const productImages = document.querySelectorAll('.product__media-item'); // All product images

          if (variantSelect) {
            variantSelect.addEventListener('change', () => {
              const selectedVariantId = variantSelect.value; // Get the selected variant ID
              // Loop through all images and update visibility based on selected variant
              productImages.forEach((mediaItem) => {
                const mediaVariantIds = mediaItem.getAttribute('data-variant-ids'); // Get associated variant IDs
                if (mediaVariantIds && mediaVariantIds.includes(selectedVariantId)) {
                  mediaItem.style.display = 'block'; // Show the image
                } else {
                  mediaItem.style.display = 'none'; // Hide the image
                }
              });
            });
          }
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;
        var varColour = activeMedia.getAttribute("data-swatch-alt");
        try {
          const buttons = document.querySelectorAll(".product-form__buttons button");
          buttons.forEach(button => {
            button.style.backgroundColor = varColour;
          });
        } catch (error) {
          
        }
        var allVariantImages = document.querySelectorAll('[data-swatch-alt="'+varColour+'"]');

        // Hide all media and remove active class
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
          element.style.display = 'none';
        });
        allVariantImages.forEach((element) => {
          element.classList.add('is-active');
          element.style.display = 'block';
        });
        // Show and mark the active media
        // activeMedia.classList.add('is-active');
        // activeMedia.style.display = 'block';

        if (prepend) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }

            const parentUl = document.querySelector(".parentul");
            if (parentUl && activeThumbnail) {
              parentUl.setAttribute("data-color", activeThumbnail.getAttribute("thumbnail-alt"));
            }

            const uls = document.querySelectorAll('[data-color]');
            if (uls.length > 0) {
              const dynamicAttributeValue = uls[0].getAttribute('data-color');
              this.toggleListItems(uls, 'thumbnail-alt', dynamicAttributeValue);
            }

            const mobileScreenWidth = 768;
            const parentUlmain = document.querySelector(".parentul-main");
            if (parentUlmain && activeThumbnail) {
              parentUlmain.setAttribute("data-main-color", activeThumbnail.getAttribute("thumbnail-alt"));
            }

            const ulsMain = document.querySelectorAll('[data-main-color]');
            if (ulsMain.length > 0) {
              const dynamicDiffAttributeValue = ulsMain[0].getAttribute("data-main-color");
              this.mobileOnlyToggle(mobileScreenWidth, ulsMain, 'thumbnail-alt', dynamicDiffAttributeValue);
            }

            window.addEventListener('resize', () => {
              if (ulsMain.length > 0) {
                const dynamicDiffAttributeValue = ulsMain[0].getAttribute("data-main-color");
                this.mobileOnlyToggle(mobileScreenWidth, ulsMain, "thumbnail-alt", dynamicDiffAttributeValue);
              }
            });
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail ? activeThumbnail.dataset.mediaPosition : '');
      }

      fetchProductData(variantId) {
        fetch(`/products/${window.location.pathname.split('/').pop()}.js`)
          .then((response) => response.json())
          .then((data) => {
            // Find the variant details from the response
            const variant = data.variants.find((v) => v.id === parseInt(variantId));
            if (variant) {
              this.updateProductSection(variant, data);
            }
          })
          .catch((error) => {
            console.error('Error fetching product data:', error);
          });
      }

      updateProductSection(variant, data) {
        const productImages = document.getElementById('product-images');
        const productPrice = document.getElementById('product-price');

        // Clear current images and update with variant-specific images
        productImages.innerHTML = '';
        data.media.forEach((media) => {
          if (media.media_type === 'image' && media.variant_ids.includes(variant.id)) {
            const imgElement = document.createElement('img');
            imgElement.src = media.src;
            imgElement.alt = media.alt;
            productImages.appendChild(imgElement);
          }
        });

        // Update price for the selected variant
        productPrice.innerHTML = `<span class="price">${variant.price / 100} USD</span>`;
        // Optionally, update other content like description or availability here.
      }

      toggleListItems(uls, attributeName, dynamicAttributeValue) {
        uls.forEach((ul) => {
          const lis = ul.querySelectorAll("li");
          lis.forEach((li) => {
            const attrValue = li.getAttribute(attributeName);
            li.style.display = attrValue === dynamicAttributeValue ? "block" : "none";
          });
        });
      }

      mobileOnlyToggle(mobileScreenWidth, uls, attributeName, dynamicAttributeValue) {
        if (window.innerWidth > mobileScreenWidth) return;
        uls.forEach((ul) => {
          const lis = ul.querySelectorAll("li");
          lis.forEach((li) => {
            const attrValue = li.getAttribute(attributeName);
            li.style.display = attrValue === dynamicAttributeValue ? "flex" : "none";
            li.classList.toggle("mobile-list-item");
          });
        });
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', 'true');
        if (this.elements.thumbnails.isSlideVisible && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };
        // Force image reload to trigger onload
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        if (this.elements.viewer.sliderItems) {
          this.elements.viewer.sliderItems.forEach((slide) =>
            slide.setAttribute('role', 'presentation')
          );
        }
      }
    }
  );
}
